module.exports = __webpack_public_path__ + "media/images/icons/hospital-b7897c79894d0ea319ce49993797ab7d.svg";